export interface SignboardRemoval {
  removalType: SignboardRemovalType;
  specificDate?: string;
}

export enum SignboardRemovalType {
  UponSettlement = 'UponSettlement',
  OnSpecificDate = 'OnSpecificDate',
  NoSignboardInstalled = 'NoSignboardInstalled',
}
